import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../../../shared/_guards/auth.guard';
import { MarketingComponent } from './marketing/marketing.component';
import { RewardsCatalogComponent } from './rewards-catalog/rewards-catalog.component';
import { PromotionsComponent } from './promotions/promotions.component';
import { RewardsCatalogNewRewardComponent } from './rewards-catalog-new-reward/rewards-catalog-new-reward.component';
import { PromotionsNewPromoComponent } from './promotions-new-promo/promotions-new-promo.component';
const routes: Routes = [
  {
    path: 'marketing', component: MarketingComponent, canActivate: [AuthGuard],
    children: [
      { path: 'rewards-catalog', pathMatch: 'full', component: RewardsCatalogComponent, canActivate: [AuthGuard] },
      { path: 'promotions', pathMatch: 'full', component: PromotionsComponent, canActivate: [AuthGuard] },
      { path: 'rewards-catalog/new-reward', pathMatch: 'full', component: RewardsCatalogNewRewardComponent, canActivate: [AuthGuard] },
      { path: 'rewards-catalog/edit-reward/:id', pathMatch: 'full', component: RewardsCatalogNewRewardComponent, canActivate: [AuthGuard] },
      { path: 'promotions/add', pathMatch: 'full', component: PromotionsNewPromoComponent, canActivate: [AuthGuard] },
      { path: 'promotions/edit/:id', pathMatch: 'full', component: PromotionsNewPromoComponent, canActivate: [AuthGuard] }
    ]
  }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MarketingRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/marketing/marketing-routing.module.ts